// package
import { Fragment, useState, useEffect } from "react";
import { Link, useSearchParams, useNavigate } from "react-router-dom";
import {
  Button,
  Card,
  Col,
  Row,
  OverlayTrigger,
  Tooltip,
  Form,
  Spinner,
} from "react-bootstrap";
import AmlHashForm from "aml-hash-form";

// component
import PageBreadcrumb from "elements/System/PageBreadcrumb";
import FieldSelect from "elements/System/FieldSelect";
import AgDelete from "elements/System/AgDelete";
import AgStatus from "elements/System/AgStatus";
import { api, common } from "includes";

export default function AddScannerFeeds() {
  // const
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  let mode = searchParams.get("mode");
  let id = searchParams.get("id");

  // state
  const [process, setProcess] = useState<any>({ result: 100 });
  const [confirm, setConfirm] = useState<any>({ id: null, type: null });
  const [submit, setSubmit] = useState<any>("");
  const [resultList, setResultList] = useState<any>(null);
  const [finder, setFinder] = useState({
    locality: true,
  });
  const [effectField, setEffectField] = useState<any>([]);
  const [permission] = useState(common.getUserPermission());

  // form
  const formFields = {
    locality: {
      validate: ["objValReq#Locality is required!"],
      obj: "value",
    },
    name: { validate: ["req#Name is required"] },
    url: { validate: [""] },
  };

  const {
    fields,
    errors,
    handleChange,
    handleSubmit,
    setValue,
    setMultiValue,
  } = AmlHashForm(formFields);

  // effect
  useEffect(() => {
    if (id) {
      getData();
    } else {
      processState("result", 200);
    }
  }, []);

  useEffect(() => {
    if (id) {
      getData();
    } else {
      processState("result", 200);
    }
  }, [mode]);

  useEffect(() => {
    if (effectField.length > 0) {
      setValue(effectField[0], effectField[1]);
      setFinder((prev) => ({ ...prev, [effectField[0]]: false }));
    }
  }, [effectField]);

  useEffect(() => {
  }, [fields]);

  // api
  const getData = () => {
    processState("result", 100);
    let data: any = {
      url: `admin/feed/${id}`,
      method: "GET",
    };
    api.call(data, (res: any) => {
      processState("result", res.status);
      if (res.status === 200) {
        let result = res.data;
        setResultList(result);
        setMultiValue({
          locality: result.locality?._id || "",
          name: result.name || "",
          url: result.url || "",
        });
      }
    });
  };

  const save = () => {
    let data = common.formPayload(fields, []);
    data.locality = fields?.locality?.value;

    let param = {
      url: id ? `admin/feed/${id}` : `admin/feed/`,
      method: id ? "PUT" : "POST",
      body: data,
    };

    api.call(param, (res: any) => {
      if (res.status === 200) {
        common.notify("S", "Scanner Feeds Updated Successfully");
        if (id) {
          navigate(`/feed/form?id=${id}&mode=view`);
          processState("result", 100);
          getData();
        } else {
          navigate(`/feed/list`);
        }
      } else {
        common.notify("E", res?.data.error);
      }
      setSubmit("");
    });
  };

  const deleteLocality = () => {
    let data: any = {
      url: `admin/feed/${confirm.id}`,
      method: "DELETE",
    };

    api.call(data, (res: any) => {
      if (res.status === 200) {
        setConfirm({ id: null, type: "" });
        common.notify("S", "Scanner feeds deleted successfully");
        navigate(`/feed/list`);
      } else {
        common.notify("E", res.error);
      }
    });
  };

  // events
  const onSubmit = (e: any) => {
    e.preventDefault();
    const isValid = handleSubmit();
    if (isValid) {
      setSubmit("submit");
      save();
    }
  };

  const deleteCallBack = (isDelete: boolean) => {
    if (isDelete) {
      deleteLocality();
    } else {
      setConfirm({ id: null, type: "" });
    }
  };

  // callback
  const onAgCallBack = (status: any) => {
    getData();
  };

  // support
  const processState = (label: any, value: any) => {
    setProcess((prev: any) => ({
      ...prev,
      [label]: value,
    }));
  };

  return (
    <Fragment>
      <PageBreadcrumb
        breadCrumbItems={[
          { label: "Scanner Feeds", path: "/feed/list" },
          { label: "Scanner Feeds Form", path: "/feed/list", active: true },
        ]}
        title={"Scanner Feeds Form"}
      />
      {process.result != 200 ? (
        <AgStatus
          process={process.result}
          message={{
            100: "Loading... Please wait!",
            404: "Something went wrong! Please Refresh Again",
          }}
          button={{ 400: "Refresh", 404: "Refresh" }}
          size="l"
          onAgCallBack={onAgCallBack}
        />
      ) : (
        <Fragment>
          {mode != "view" ? (
            <Fragment>
              {" "}
              <Row>
                <Col xl={12} lg={12}>
                  <Card>
                    <Card.Body className="py-1 px-1 border-bottom border-light">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="float-start">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id="">Back</Tooltip>}
                          >
                            <Link
                              to="/feed/list"
                              className="text-reset fs-20 p-1 d-inline-block"
                            >
                              <i
                                className="ri-arrow-left-s-line pe-2"
                                data-bs-container="#tooltips-container"
                                data-bs-toggle="tooltip"
                              />
                            </Link>
                          </OverlayTrigger>
                          <label className="form-check-label fs-16">
                            {id ? "Edit" : "Add"} Scanners Feeds
                          </label>
                        </div>
                        <div id="tooltips-container d-flex align-items-center">
                          <div className="d-flex flex-wrap gap-2">
                            <Button
                              variant="secondary"
                              onClick={() => {
                                navigate("/feed/list");
                              }}
                              disabled={submit === "submit"}
                            >
                              <i className=" ri-arrow-go-back-line me-1" />
                              Cancel
                            </Button>
                            <Button
                              variant="primary"
                              onClick={onSubmit}
                              disabled={submit === "submit"}
                            >
                              {submit === "submit" ? (
                                <>
                                  <Spinner
                                    className="spinner-border-sm me-1"
                                    color="white"
                                  />
                                  Processing...
                                </>
                              ) : (
                                <>
                                  <i className="ri-save-line" /> Save
                                </>
                              )}
                            </Button>
                          </div>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Card>
                    <Card.Body>
                      <Form>
                        <Row>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Locality</Form.Label>
                              <FieldSelect
                                api="admin/locality"
                                query="?offset=1&limit=1000"
                                get="name"
                                set="_id"
                                value={fields?.locality}
                                placeholder="Select locality"
                                render={"yes"}
                                clearable={true}
                                finder={finder?.locality}
                                multi={false}
                                onSelect={(data: any) => {
                                  setEffectField(["locality", data]);
                                }}
                              />
                              <p className="text-danger fs-6">
                                {errors.locality}
                              </p>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Name</Form.Label>
                              <Form.Control
                                type="text"
                                name="name"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                placeholder="Enter feeds name"
                                value={fields.name}
                                onChange={handleChange}
                                isInvalid={errors.name ? true : false}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.name}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                          <Col md={6}>
                            <Form.Group className="mb-3">
                              <Form.Label>Url</Form.Label>
                              <Form.Control
                                type="text"
                                name="url"
                                id="singleLine"
                                maxLength={100}
                                data-toggle="maxlength"
                                placeholder="Enter Url"
                                value={fields.url}
                                onChange={handleChange}
                                isInvalid={errors.url ? true : false}
                              />
                              <Form.Control.Feedback type="invalid">
                                {errors.url}
                              </Form.Control.Feedback>
                            </Form.Group>
                          </Col>
                        </Row>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Fragment>
          ) : (
            <Fragment>
              <Row>
                <Col xl={12} lg={12}>
                  <Card>
                    <Card.Body className="py-1 px-1 border-bottom border-light">
                      <div className="d-flex align-items-center justify-content-between">
                        <div className="float-start">
                          <OverlayTrigger
                            placement="bottom"
                            overlay={<Tooltip id="">Back</Tooltip>}
                          >
                            <Link
                              to="/feed/list"
                              className="text-reset fs-20 p-1 d-inline-block"
                            >
                              <i
                                className="ri-arrow-left-s-line pe-2"
                                data-bs-container="#tooltips-container"
                                data-bs-toggle="tooltip"
                              />
                            </Link>
                          </OverlayTrigger>
                          <label className="form-check-label fs-16">
                            Scanner feeds Information
                          </label>
                        </div>
                        {permission.includes("sfu") && <div id="tooltips-container d-flex align-items-center">
                          <div className="d-flex flex-wrap gap-2">
                            <OverlayTrigger
                              placement="bottom"
                              overlay={<Tooltip id="">Edit</Tooltip>}
                            >
                              <Button
                                className="btn btn-light"
                                onClick={() => {
                                  navigate(`/feed/form?id=${id}&mode=edit`);
                                }}
                              >
                                <i
                                  className="ri-edit-2-line"
                                  data-bs-container="#tooltips-container"
                                  data-bs-toggle="tooltip"
                                />
                              </Button>
                            </OverlayTrigger>
                          </div>
                        </div>}
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>

              <Row>
                <Col>
                  <Card>
                    <Card.Body>
                      <Form>
                        <Row>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Locality</Form.Label>
                              <p className="text-muted fs-14">
                                {resultList?.locality?.name || "-"}
                              </p>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Name</Form.Label>
                              <p className="text-muted fs-14">
                                {resultList.name || "-"}
                              </p>
                            </Form.Group>
                          </Col>
                          <Col md={4}>
                            <Form.Group className="mb-3">
                              <Form.Label>Url</Form.Label>
                              <p className="text-muted fs-14">
                                <Link
                                  to={resultList.url ? resultList.url : "#"}
                                  target="_blank"
                                >
                                  {resultList.url || "-"}
                                </Link>
                              </p>
                            </Form.Group>
                          </Col>
                          {permission.includes("scd") && <Col md={4}>
                            <Button
                              variant="danger"
                              size="sm"
                              className="me-1 d-felx align-items-center"
                              onClick={() =>
                                setConfirm({ id: id, type: "locality" })
                              }
                            >
                              <i className="ri-delete-bin-line fs-16" />
                              <span className="ms-1">
                                Permanently Delete Scanner feeds
                              </span>
                            </Button>
                          </Col>}
                        </Row>
                      </Form>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Fragment>
          )}
        </Fragment>
      )}
      {/* Delete confirmation */}
      {confirm.id && (
        <AgDelete type="delete" onAgDeleteCallBack={deleteCallBack} />
      )}
    </Fragment>
  );
}
